const Terms = () => {
    return (
        <div>
            This is the Terms page.
        </div>
    )
}

export default Terms